export enum TipoParentescoEnum {
    HIJO = '1',
    HIJASTRO = '2',
    PADRE = '3',
    MADRE = '33',
    HERMANO = '4',
    CONYUGE = '5',
}

const parentescoMapeado: Record<TipoParentescoEnum, string> = {
    [TipoParentescoEnum.CONYUGE]: 'SUB-0002',
    [TipoParentescoEnum.HIJO]: 'SUB-0003',
    [TipoParentescoEnum.HERMANO]: 'SUB-0004',
    [TipoParentescoEnum.HIJASTRO]: 'SUB-0005',
    [TipoParentescoEnum.PADRE]: 'SUB-0008',
    [TipoParentescoEnum.MADRE]: 'SUB-0009',
};

export function obtenerValorMapeado(parentesco: TipoParentescoEnum): string {
    return parentescoMapeado[parentesco];
}

export enum ParentescoMapeadoEnum {
    CONYUGE = 'SUB-0002',
    HIJO = 'SUB-0003',
    HERMANO = 'SUB-0004',
    HIJASTRO = 'SUB-0005',
    PADRE = 'SUB-0008',
    MADRE = 'SUB-0009',
  }

  export function obtenerValorMapeadoEsp(tipo: string): string {
    const tipoNormalizado = tipo.toUpperCase();

    return ParentescoMapeadoEnum[tipoNormalizado as keyof typeof ParentescoMapeadoEnum] || "";
  }

export function obtenerTipoDesdeCodigo(codigo: string): string {
  const entrada = Object.entries(ParentescoMapeadoEnum).find(
    ([_, valor]) => valor === codigo
  );
  return entrada ? entrada[0] : "";
}
